module.exports = __webpack_public_path__ + "img/PT61.f8fe573f.png";